export function formatBps(bps, intl) {
  return intl.formatNumber(bps / 10000, {
    style: 'percent',
    maximumFractionDigits: 3
  });
}
function parsePhone(phoneNumber) {
  let output;
  const regex = /\D/g;
  if (phoneNumber && phoneNumber[0] === '+') {
    const stripped = phoneNumber.replace(regex, '');
    if (stripped.length === 11) {
      output = stripped.slice(1, 11);
    }
  }
  return output;
}
export function formatPhone(phoneNumber, {
  uri = false
} = {}) {
  let formatted;

  // return `undefined` unless the phone number is a 10-digit US number prefixed
  // with a ‘+1’. This loosely represents a number that would fail to parse with
  // libphonenumber-js’ `parsePhoneNumberFromString` function.
  const digits = parsePhone(phoneNumber);
  if (digits && uri) {
    formatted = `tel:+1${digits}`;
  } else if (digits) {
    const area = digits.slice(0, 3);
    const local = digits.slice(3, 6);
    const last = digits.slice(6, 10);
    formatted = `${area}-${local}-${last}`;
  }
  return formatted;
}